import React from 'react';
import Flux  from '../../../flux/Flux';

function withVideoRecommendationsFromVideoStation(T) {
	class VideoRecommendationsFromVideoStation extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				jumbotronCategories: [],
			};

			this.onJumbotronConfigUpdated = this.onJumbotronConfigUpdated.bind(this);
		}

		componentDidMount() {
			Flux.Video.Jumbotron.addConfigChangeListener(this.onJumbotronConfigUpdated);

			const conf = Flux.Video.Jumbotron.getConfig();
			if (conf && conf.categories) {
				this.onJumbotronConfigUpdated(conf);
			} else {
				Flux.Video.Jumbotron.loadConfig();
			}
		}

		componentWillUnmount() {
			Flux.Video.Jumbotron.removeConfigChangeListener(this.onJumbotronConfigUpdated);
		}

		/**
		 * @param {?{categories: Array}} config
		 */
		onJumbotronConfigUpdated(config) {
			const categoriesReordered = [];
			if (config && config.categories && config.categories.length === 4) {
				categoriesReordered.push(config.categories[1]);
				categoriesReordered.push(config.categories[3]);
				categoriesReordered.push(config.categories[2]);
			}

			this.setState({jumbotronCategories: categoriesReordered});
		}

		render() {
			return <T {...this.state} {...this.props} />;
		}
	}

	return VideoRecommendationsFromVideoStation;
}

export default withVideoRecommendationsFromVideoStation;
